import { clientApi } from '@/config/axios';
export interface CourseTask {
  id: string;
  type: string;
  label: string;
  subject_id: string;
  source_event_id: string;
  due_from: string;
  due_until: string;
  status: string;
  configuration_version: number;
  booking?: { encounter_id: string; scheduled_at: string; assigned_to: string | null; source_changed: boolean } | null;
}
export interface CourseTaskSchedule {
  task_id: string;
  source_event_id: string;
  configuration_version: number;
  scheduled_at: string;
  assigned_to: string | null;
  confirmed: true;
}
export async function scheduleCourseTask(orgId: string, episodeId: string, input: CourseTaskSchedule) {
  return (
    await clientApi.post(`/api/v1/organizations/${orgId}/flowsheets/episodes/${episodeId}/postpartum-scheduling`, input)
  ).data;
}
export interface PostpartumCourseData {
  episode_id: string;
  encounters: {
    id: string;
    date: string;
    label: string;
    patient_id: string;
    pregnancy_id?: string | null;
    allowed_subject_ids?: string[];
    scheduled_at: string | null;
  }[];
  events: import('./types').ClinicalEvent[];
  tasks: CourseTask[];
  epds: {
    event_id: string;
    subject_id: string;
    encounter_id: string;
    total: number;
    item_10_positive: boolean;
    threshold_reached: boolean;
    source: string;
    diagnostic: false;
  }[];
}
export async function fetchPostpartumCourse(orgId: string, episodeId: string): Promise<PostpartumCourseData> {
  return (await clientApi.get(`/api/v1/organizations/${orgId}/flowsheets/episodes/${episodeId}/postpartum-course`))
    .data;
}
